import React from "react";
import { capitalize } from "../../../helpers/capitalize";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ViewLoanTransModal = ({
  id,
  openViewLoanTransModal,
  closeTransactionDetails,
  singleTransaction,
  customerDetails,
  openViewReceipt,
}) => {
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
    hour12: true,
  };

  const formatName = (name) =>
    name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : "";

  const handleDownloadReceipt = async () => {
    // Create a clone of the receipt template
    const element = document.getElementById("receipt-template");
    if (!element) return;
    const firstName = formatName(customerDetails?.data?.firstname);
    const lastName = formatName(customerDetails?.data?.lastname);

    const fullName = `${firstName}_${lastName}`.trim();

    // Clone the element and append it off-screen
    const clone = element.cloneNode(true);
    clone.style.position = "absolute";
    clone.style.left = "-9999px";
    clone.style.top = "0";
    clone.style.display = "flex"; // Ensure it's visible for html2canvas
    document.body.appendChild(clone);

    // Capture the clone
    const canvas = await html2canvas(clone, {
      scale: 2,
      useCORS: true,
      logging: false,
    });

    // Convert to JPEG and generate PDF
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${fullName}_receipt.pdf`);

    // Clean up the clone
    document.body.removeChild(clone);
  };

  return (
    <>
      <div
        id={id}
        className={`${
          openViewLoanTransModal ? "flex" : "hidden"
        } fixed inset-0 z-50 items-center justify-center bg-gray-800 bg-opacity-50 overflow-auto`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow w-[40%] mx-auto rounded-lg">
            <div className="">
              {/* Header */}
              <div
                onClick={closeTransactionDetails}
                className="absolute right-[0px] cursor-pointer w-[40px] h-[40px] top-[0px] flex items-center justify-center"
              >
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="1.06058"
                    y1="0.353478"
                    x2="18.3557"
                    y2="17.6486"
                    stroke="black"
                  />
                  <line
                    y1="-0.5"
                    x2="24.459"
                    y2="-0.5"
                    transform="matrix(-0.707107 0.707107 0.707107 0.707107 18.0024 0.707031)"
                    stroke="black"
                  />
                </svg>
              </div>
              <div className="flex-col flex justify-end mt-8 px-8 h-[8vh]">
                <p className="text-[#000000] text-[20px] font-[600]">
                  Transaction Details
                </p>
              </div>

              <div
                className="flex-col flex justify-center rounded-lg mt-5 px-5 w-[92%] mx-auto"
                style={{
                  border: "0.7px solid var(--Grey-for-non-actve, #E8E8E8)",
                }}
              >
                <div className="flex items-center justify-between py-3">
                  <div className="flex items-center gap-5">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="50"
                        height="50"
                        rx="25"
                        fill="url(#paint0_linear_17225_7135)"
                      />
                      <path
                        d="M25.5 16.1725V24.5001C25.5 24.6907 25.4243 24.8735 25.2895 25.0083C25.1547 25.1431 24.9719 25.2188 24.7812 25.2188C24.5906 25.2188 24.4078 25.1431 24.273 25.0083C24.1382 24.8735 24.0625 24.6907 24.0625 24.5001V16.1725L22.4148 17.8211C22.2799 17.956 22.097 18.0317 21.9062 18.0317C21.7155 18.0317 21.5326 17.956 21.3977 17.8211C21.2629 17.6862 21.1871 17.5033 21.1871 17.3126C21.1871 17.1218 21.2629 16.9389 21.3977 16.8041L24.2727 13.9291C24.3395 13.8622 24.4188 13.8092 24.506 13.773C24.5933 13.7369 24.6868 13.7183 24.7812 13.7183C24.8757 13.7183 24.9692 13.7369 25.0565 13.773C25.1437 13.8092 25.223 13.8622 25.2898 13.9291L28.1648 16.8041C28.2996 16.9389 28.3754 17.1218 28.3754 17.3126C28.3754 17.5033 28.2996 17.6862 28.1648 17.8211C28.0299 17.956 27.847 18.0317 27.6562 18.0317C27.4655 18.0317 27.2826 17.956 27.1477 17.8211L25.5 16.1725ZM31.25 24.1066V21.6251C31.25 21.2438 31.0985 20.8782 30.829 20.6086C30.5594 20.339 30.1937 20.1876 29.8125 20.1876H28.375C28.1844 20.1876 28.0016 20.2633 27.8668 20.3981C27.732 20.5329 27.6562 20.7157 27.6562 20.9063C27.6562 21.097 27.732 21.2798 27.8668 21.4146C28.0016 21.5494 28.1844 21.6251 28.375 21.6251H29.8125V28.8485C29.3839 28.4106 28.8102 28.1443 28.1991 28.0994C27.588 28.0545 26.9815 28.2342 26.4935 28.6048C26.0055 28.9753 25.6695 29.5112 25.5487 30.1119C25.4278 30.7126 25.5303 31.3368 25.8369 31.8673L25.8585 31.9014L27.8584 34.9561C27.9628 35.1156 28.1262 35.2272 28.3128 35.2662C28.4994 35.3052 28.6939 35.2684 28.8534 35.1641C29.0129 35.0597 29.1245 34.8962 29.1635 34.7096C29.2025 34.523 29.1658 34.3286 29.0614 34.1691L27.0732 31.1332C26.9322 30.8844 26.8959 30.5897 26.9722 30.314C27.0486 30.0384 27.2313 29.8043 27.4802 29.6634C27.729 29.5225 28.0237 29.4862 28.2994 29.5625C28.575 29.6388 28.8091 29.8215 28.95 30.0704C28.9563 30.0821 28.9635 30.0937 28.9707 30.1045L29.9302 31.5699C30.015 31.6992 30.1393 31.7978 30.2846 31.8509C30.4299 31.9039 30.5884 31.9087 30.7366 31.8645C30.8848 31.8203 31.0149 31.7295 31.1074 31.6055C31.1998 31.4816 31.2499 31.331 31.25 31.1764V25.9376C31.9275 26.5647 32.4685 27.3246 32.8395 28.1699C33.2105 29.0153 33.4034 29.928 33.4062 30.8511V34.5626C33.4062 34.7532 33.482 34.936 33.6168 35.0708C33.7516 35.2056 33.9344 35.2813 34.125 35.2813C34.3156 35.2813 34.4984 35.2056 34.6332 35.0708C34.768 34.936 34.8438 34.7532 34.8438 34.5626V30.8475C34.8397 29.5161 34.5101 28.2058 33.8837 27.0309C33.2574 25.856 32.3532 24.852 31.25 24.1066ZM21.1875 20.1876H19.75C19.3688 20.1876 19.0031 20.339 18.7335 20.6086C18.464 20.8782 18.3125 21.2438 18.3125 21.6251V30.9688C18.3125 31.1595 18.3882 31.3423 18.523 31.4771C18.6578 31.6119 18.8406 31.6876 19.0312 31.6876C19.2219 31.6876 19.4047 31.6119 19.5395 31.4771C19.6743 31.3423 19.75 31.1595 19.75 30.9688V21.6251H21.1875C21.3781 21.6251 21.5609 21.5494 21.6957 21.4146C21.8305 21.2798 21.9062 21.097 21.9062 20.9063C21.9062 20.7157 21.8305 20.5329 21.6957 20.3981C21.5609 20.2633 21.3781 20.1876 21.1875 20.1876Z"
                        fill="#029902"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_17225_7135"
                          x1="14.5"
                          y1="3.5"
                          x2="35"
                          y2="50"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#E6FFEF" />
                          <stop offset="1" stop-color="#ABEBC2" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="flex-col flex justify-center">
                      <p className="text-[#000000] text-[14px] font-normal">
                        Deposit to {singleTransaction?.note} Account
                      </p>
                      <p className="text-[#06B217] text-[14px] font-normal">
                        {singleTransaction?.payment_code}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-[#000000] text-[20px] font-[600]">
                    KES{" "}
                    {Number(
                      singleTransaction?.payment_amount || "0.00",
                    )?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>

              {/* Transaction Details */}
              <div className="mt-5 sm:mt-6 px-3 sm:px-5 mb-10">
                {/* Details */}
                <div className="space-y-3 sm:space-y-4 text-[14px] sm:text-[15px]">
                  {[
                    ["Transaction ID", singleTransaction?.payment_code],
                    [
                      "Transaction Date/Time",
                      singleTransaction?.payment_date
                        ? new Intl.DateTimeFormat("en-US", dateOptions).format(
                            new Date(singleTransaction?.payment_date),
                          )
                        : "N/A",
                    ],
                    ["Member ID", `#${customerDetails?.data?.public_id}`],
                    [
                      "Member Name",
                      `${customerDetails?.data?.firstname
                        ?.charAt(0)
                        ?.toUpperCase()}${customerDetails?.data?.firstname
                        ?.slice(1)
                        ?.toLowerCase()} ${customerDetails?.data?.lastname
                        ?.charAt(0)
                        ?.toUpperCase()}${customerDetails?.data?.lastname
                        ?.slice(1)
                        ?.toLowerCase()}`,
                    ],
                    ["Phone Number", singleTransaction?.payment_mobile],
                    [
                      "Transaction Amount",
                      `KES ${Number(
                        singleTransaction?.payment_amount || "0.00",
                      )?.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`,
                    ],
                    [
                      "Transaction Reference Number",
                      singleTransaction?.payment_ref_no,
                    ],
                    [
                      "Loan Code",
                      capitalize(singleTransaction?.loan_code) || "N/A",
                    ],
                  ]?.map(([label, value], idx) => (
                    <div
                      key={idx}
                      className="flex flex-col justify-between sm:flex-row w-full sm:w-[99%]"
                    >
                      <p className="text-[#000000] font-bold">{label}</p>
                      <p className="text-[#000000] break-all">{value}</p>
                    </div>
                  ))}

                  {singleTransaction?.payment_document_url && (
                    <div className="flex  justify-between flex-col sm:flex-row w-full sm:w-[99%]">
                      <p className="text-[#000000] font-bold text-[15px]">
                        Receipt
                      </p>
                      <p
                        onClick={() =>
                          openViewReceipt(
                            singleTransaction?.payment_document_url,
                          )
                        }
                        className="text-[#06B217] text-[15px] truncate cursor-pointer"
                      >
                        {singleTransaction?.payment_document_url
                          ? singleTransaction?.payment_document_url
                              ?.split("/")
                              ?.pop()
                              ?.slice(-40)
                          : ""}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-center mt-20 mx-auto mb-8 gap-5">
                <div
                  onClick={handleDownloadReceipt}
                  className="flex items-center justify-center bg-[#E8E8E8] gap-3 py-3 w-[44%] rounded-lg cursor-pointer"
                >
                  <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.75 12.254V13.25C0.75 14.0456 1.06607 14.8087 1.62868 15.3713C2.19129 15.9339 2.95435 16.25 3.75 16.25H13.75C14.5456 16.25 15.3087 15.9339 15.8713 15.3713C16.4339 14.8087 16.75 14.0456 16.75 13.25V12.25M8.75 0.75V11.75M8.75 11.75L12.25 8.25M8.75 11.75L5.25 8.25"
                      stroke="#005C53"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p className="text-[16px] font-[500]">Download Receipt</p>
                </div>
              </div>

              <div
                id="receipt-template"
                className="hidden w-full max-w-[550px] bg-white flex flex-col min-h-[110vh] mx-auto"
              >
                {/* Upper area */}
                <div className="bg-[#E8E8E8] w-full px-5 py-5 flex-shrink-0">
                  <div className="flex items-center justify-between mb-6">
                    <img src="/logo.png" alt="Logo" className="z-50" />
                    <div className="flex flex-col text-right">
                      {(() => {
                        const now = new Date();
                        const dateOptions = {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        };
                        const timeOptions = {
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        };
                        const currentDate = new Intl.DateTimeFormat(
                          "en-US",
                          dateOptions,
                        ).format(now);
                        const currentTime = new Intl.DateTimeFormat(
                          "en-US",
                          timeOptions,
                        ).format(now);
                        return (
                          <>
                            <p className="text-[7px] sm:text-[9px] text-[#000000] font-normal">
                              {currentDate}
                            </p>
                            <p className="text-[7px] sm:text-[9px] text-[#000000] font-normal mt-2">
                              {currentTime}
                            </p>
                          </>
                        );
                      })()}
                    </div>
                  </div>

                  <div className="flex justify-between items-start mb-3">
                    <div className="pr-4 max-w-[60%] flex flex-col justify-between">
                      <p className="text-[16px] sm:text-[18px] text-[#000000] font-[600] mb-2 break-words">
                        Your transaction is complete.
                      </p>
                      <p className="text-[16px] sm:text-[18px] text-[#000000] font-[600] mb-2 break-words">
                        Thanks for choosing us, <br />
                        {`${formatName(
                          customerDetails?.data?.firstname,
                        )} ${formatName(customerDetails?.data?.lastname)}`}
                        .
                      </p>
                      <p className="text-[8px] sm:text-[10px] text-[#000000] break-words">
                        We hope this step brings you closer to your goals.
                      </p>
                    </div>
                    {/* <img
                      src="/receipt.png"
                      alt="Receipt"
                      className="object-contain h-[75px] sm:h-[100px] md:h-[120px]"
                    /> */}
                  </div>
                </div>

                {/* Transaction details - flex-grow to push footer down */}
                <div className="flex-grow flex flex-col items-center justify-start mx-auto w-[92%] mt-5 space-y-2 break-words">
                  {[
                    ["Transaction ID", singleTransaction?.payment_code],
                    [
                      "Transaction Date/Time",
                      singleTransaction?.payment_date
                        ? new Intl.DateTimeFormat("en-US", dateOptions).format(
                            new Date(singleTransaction?.payment_date),
                          )
                        : "N/A",
                    ],
                    ["Member ID", `${customerDetails?.data?.public_id}`],
                    [
                      "Member Name",
                      `${customerDetails?.data?.firstname
                        ?.charAt(0)
                        ?.toUpperCase()}${customerDetails?.data?.firstname
                        ?.slice(1)
                        ?.toLowerCase()} ${customerDetails?.data?.lastname
                        ?.charAt(0)
                        ?.toUpperCase()}${customerDetails?.data?.lastname
                        ?.slice(1)
                        ?.toLowerCase()}`,
                    ],
                    ["Phone Number", singleTransaction?.payment_mobile],
                    [
                      "Transaction Amount",
                      `KES ${Number(
                        singleTransaction?.payment_amount || "0.00",
                      )?.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`,
                    ],
                    [
                      "Transaction Reference Number",
                      singleTransaction?.payment_ref_no,
                    ],
                    [
                      "Loan Code",
                      capitalize(singleTransaction?.loan_code) || "N/A",
                    ],
                  ]?.map(([label, value], idx) => (
                    <div
                      key={idx}
                      className="flex flex-col justify-between sm:flex-row w-full sm:w-[99%]"
                    >
                      <p className="text-[#000000] font-normal">{label}</p>
                      <p className="text-[#000000] font-normal break-all">
                        {value}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Footer - pushed almost to bottom */}
                <div className="justify-start mx-auto w-[92%] pt-5 pb-5 flex-shrink-0">
                  <p className="text-[6px] sm:text-[8px] text-[#000000] font-[400] break-words">
                    This receipt was generated by Anansi Ltd on behalf of your
                    SACCO. All transactions are processed securely and <br />
                    in accordance with applicable Kenyan financial regulations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewLoanTransModal;
